module.exports = __webpack_public_path__ + "media/images/emblems/Moutier_(district)-coat_of_arms-4b6f5a954ee546aa431902d9807ac7a1.svg";